var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vue-book-demo-page" }, [
    _c(
      "div",
      {
        staticClass: "vue-book-demo-page__left-block",
        style: {
          "flex-basis": _vm.config.width + "px",
          width: _vm.config.width + "px"
        }
      },
      [
        _c(
          "div",
          { staticClass: "vue-book-demo-page__menu" },
          [
            _c("vue-book-menu", {
              attrs: { config: _vm.config, currentFile: _vm.currentFile },
              on: {
                openFolder: function($event) {
                  _vm.currentFile.openFolder()
                }
              }
            }),
            _vm._v(" "),
            _vm.config.mode === _vm.DemoPageMode.Search
              ? _c(
                  "div",
                  { staticClass: "vue-book-demo-page__menu__search" },
                  [
                    _c("vue-book-input", {
                      ref: "searchInput",
                      staticClass: "vue-book-demo-page__search-input",
                      attrs: { placeholder: "Search..." },
                      on: {
                        up: function($event) {
                          _vm.moveCursor(-1)
                        },
                        down: function($event) {
                          _vm.moveCursor(1)
                        },
                        enter: function($event) {
                          _vm.selectFileUnderCursor()
                        },
                        blur: function($event) {
                          _vm.listCursor.clean()
                        }
                      },
                      model: {
                        value: _vm.config.searchText,
                        callback: function($$v) {
                          _vm.$set(_vm.config, "searchText", $$v)
                        },
                        expression: "config.searchText"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "vue-book-demo-page__files" },
          [
            _vm.config.mode === _vm.DemoPageMode.Search
              ? _c("searchable-demo-file-list", {
                  attrs: {
                    files: _vm.filteredFiles,
                    listCursor: _vm.listCursor
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.config.mode === _vm.DemoPageMode.Tree
              ? _c("tree-demo-file-list", {
                  attrs: { folder: _vm.demoFolder, listCursor: _vm.listCursor }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("vue-book-resize-line", {
          staticClass: "vue-book-demo-page__left-block__resize-line",
          model: {
            value: _vm.config.width,
            callback: function($$v) {
              _vm.$set(_vm.config, "width", $$v)
            },
            expression: "config.width"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "vue-book-demo-page__right-block" },
      [_vm.component ? _c(_vm.component, { tag: "component" }) : _vm._e()],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }